var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMoveDownLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMoveDown",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1920 1547v106.667H533.333V1547H1920Zm0-426.773V1227H533.333v-106.773H1920ZM106.667 267.043v426.666H457.92L282.347 518.136l75.306-75.52L662.08 747.043l-304.427 304.32-75.306-75.414L457.92 800.27H0V267.043h106.667Zm960 426.624v106.666H853.333V693.667h213.334Zm426.666 0v106.666H1280V693.667h213.333Zm426.667 0v106.666h-213.333V693.667H1920ZM1920 267v106.667H533.333V267H1920Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconMoveDownLine.glyphName = 'move-down';
IconMoveDownLine.variant = 'Line';
IconMoveDownLine.displayName = 'IconMoveDownLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMoveDownLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMoveDownLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMoveDownLine;
export { IconMoveDownLine };